import React, { useEffect, useState, createElement } from 'react';
import { LoadingAnimation } from './components/LoadingAnimation';
import { Hero } from './components/Hero';
import { Philosophy } from './components/Philosophy';
import { MenuSection } from './components/MenuSection';
import { WhyBajoPerfil } from './components/WhyBajoPerfil';
import { Footer } from './components/Footer';
const TITLE = 'BAJO PERFIL — Menú';
const DESCRIPTION = 'Street food premium. Kebabs y papas horneadas. Pasto, Colombia.';
function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
function usePageMeta() {
  useEffect(() => {
    document.title = TITLE;
    upsertMeta('name', 'description', DESCRIPTION);
    upsertMeta('property', 'og:title', TITLE);
    upsertMeta('property', 'og:description', DESCRIPTION);
    upsertMeta('property', 'og:url', 'https://bajoperfil.online');
    upsertMeta('property', 'og:site_name', 'BAJO PERFIL');
  }, []);
}
export function App() {
  const [loading, setLoading] = useState(true);
  usePageMeta();
  return <div className="w-full min-h-screen bg-bp-bg" data-id="element-0">
      {loading && <LoadingAnimation onComplete={() => setLoading(false)} data-id="element-1" />}

      {/* The page sits underneath the loading overlay and is revealed after the
                black overlay bridges in (~3.8s). */}
      <Hero revealDelay={3.8} data-id="element-2" />
      <Philosophy data-id="element-3" />

      {/* Fixed tab bar + a single content zone that swaps categories in place */}
      <MenuSection data-id="element-4" />

      <WhyBajoPerfil data-id="element-5" />
      <Footer data-id="element-6" />
    </div>;
}